import ours from '@oursprivacy/cdp-sdk';

const isOursPrivacyEnabled = import.meta.env.VITE_OURS_PRIVACY_ENABLED === 'true';
const oursPrivacyToken = import.meta.env.VITE_PUBLIC_OURS_PRIVACY_TOKEN;

const isActive = isOursPrivacyEnabled && Boolean(oursPrivacyToken);

if (isActive) {
  ours.init(oursPrivacyToken, {
    track_web_events: true,
    bot_detection: true,
    custom_domain: 'https://metrics.conduithealth.com',
  });
}

export function oursIdentify(...args: Parameters<typeof ours.identify>): void {
  if (!isActive) return;
  ours.identify(...args);
}
